export const COOKIE_CONSENT_NAME = 'cookie-consent';

// Expires after 100 days
export const COOKIE_CONSENT_EXPIRATION_MS = 100 * 24 * 60 * 60 * 1000;

export const enum CookieConsentValues {
  granted = 'granted',
  denied = 'denied',
}

export const cookieOptions = {
  path: '/',
};
